import { FC } from "preact/compat";
import { useApp } from "~/core";
import CalendarMonthIcon from "@material-design-icons/svg/outlined/calendar_month.svg";
import GoogleIcon from "~/assets/google.svg";
import OutlookIcon from "~/assets/outlook.svg";

const Preview: FC = () => {
    const { api } = useApp();
    const instance = api.account.active().value;
    const Icon = instance.active
        ? instance.service === "google_cal"
            ? GoogleIcon
            : OutlookIcon
        : CalendarMonthIcon;

    return (
        <div className="flex size-full items-center justify-center">
            <Icon width="60" height="60" className="fill-gray-500" />
        </div>
    );
};

export default Preview;
